import React, { useEffect } from "react";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import _ from "lodash";
import api from "../../router/axiosConfig";
import { serverurl } from "../../router/config";

function AddrightclickPOI({ poilat, poilng, handleClose, onSuccess, onError }) {
  const [getpoigroups, GetPoiGroups] = React.useState([]);
  const [getpoicategories, GetPoiCategories] = React.useState([]);
  const [poistate, setPoistate] = React.useState({ poigroup: "", poicategory: "" });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const poigroups = await api.get(serverurl + "GetPoiGroups");
        GetPoiGroups(poigroups?.data);

        const poicategories = await api.get(serverurl + "GetPoiCategories");
        GetPoiCategories(poicategories?.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  const handlePOIGroupChange = (event) => setPoistate({ ...poistate, poigroup: event.target.value });
  const handlePOICategoryChange = (event) => setPoistate({ ...poistate, poicategory: event.target.value });

  return (
    <Box>
      <IconButton
        onClick={handleClose}
        size="small"
        style={{ position: "absolute", top: 8, right: 8, color: "grey" }}
      >
        <CloseIcon />
      </IconButton>
      <h4 style={{ margin: "0 0 16px 0", fontWeight: "600" }}>Add POI</h4>
      <Formik
        enableReinitialize
        initialValues={{ name: "", poiid: "" }}
        validate={(values) => {
          const errors = {};
          if (!values.name) errors.name = "POI Name is Required";
          if (!values.poiid) errors.poiid = "POI ID is Required";
          if (!poistate.poigroup) errors.poigroup = "POI Group is Required";
          if (!poistate.poicategory) errors.poicategory = "POI Category is Required";
          return errors;
        }}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          try {
            const poilocation = poilng && poilat ? `${poilng} ${poilat}` : "";
            const requestBody = {
              buildingName: "",
              displayIcon: "Blue.png",
              doorNumber: "",
              geom: "",
              geomText: _.toString(poilocation),
              grl: "",
              mobile: "",
              poiCategoryId: _.toString(poistate.poicategory),
              poiCode: _.toString(values.poiid),
              poiGroupId: _.toString(poistate.poigroup),
              poiId: "-1",
              poiName: values.name,
              poiTypeId: "1",
              poititles: [],
              radius: "",
              remarks: "",
              telephone: "",
              territoryId: "",
            };

            const response = await api.post(serverurl + "CreatePoi", requestBody, {
              headers: { "Content-Type": "application/json; charset=utf-8" },
            });
             if (response?.data?.status === 1) {
              onSuccess?.("POI Saved Successfully!");
              resetForm();
            } else if (response?.data?.status === -2) {
              onError?.("POI ID " + _.toString(values.poiid) + "  is already exists!");
              resetForm();
            }

            else {
              onError?.("POI Saving Failed!");
            }
          } catch (err) {
            console.error(err);
            onError?.("POI Saving Failed!");
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <TextField
              name="name"
              label="POI Name*"
              fullWidth
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
              margin="normal"
            />

            <TextField
              name="poiid"
              label="POI ID*"
              fullWidth
              type="number"
              value={values.poiid}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.poiid && Boolean(errors.poiid)}
              helperText={touched.poiid && errors.poiid}
              margin="normal"
            />

            <FormControl fullWidth margin="normal">
              <InputLabel id="poi-group-label">Select POI Group</InputLabel>
              <Select
                labelId="poi-group-label"
                id="poi-group-select"
                value={poistate.poigroup}
                label="Select POI Group"
                onChange={handlePOIGroupChange}
                error={Boolean(errors.poigroup)}
              >
                {getpoigroups?.length > 0 && getpoigroups.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.poigroup && <small style={{ color: "red" }}>{errors.poigroup}</small>}
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel id="poi-category-label">Select POI Category</InputLabel>
              <Select
                labelId="poi-category-label"
                id="poi-category-select"
                value={poistate.poicategory}
                label="Select POI Category"
                onChange={handlePOICategoryChange}
                error={Boolean(errors.poicategory)}
              >
                {getpoicategories?.length > 0 && getpoicategories.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
              {errors.poicategory && <small style={{ color: "red" }}>{errors.poicategory}</small>}
            </FormControl>

            <Box display="flex" justifyContent="center" mt={3}>
              <Button 
                type="submit" 
                variant="contained" 
                color="secondary" 
                disabled={isSubmitting}
                fullWidth
                style={{ textTransform: "none", fontWeight: "bold" }}
              >
                Add POI
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
}

export default AddrightclickPOI;
